export const GROUP_CHIP_TOOLTIPS = {
  isPublic:
    "This group is visible to the public. Anyone can view this bulletin board without being a member of the group.",
  requiresModeration:
    "Bulletins shared to this group require approval from a moderator before being visible to members",
  policeService:
    "This group represents an official police service organization",
} as const;

export const GROUP_FIELD_LABELS = {
  name: "Name",
  description: "Description",
  organization: "Organization",
  isPublic: "Public",
  requiresModeration: "Requires Moderation",
  policeService: "Police Service",
} as const;

export const USER_PERMISSION_LABELS = {
  role: "Role",
  bypassModeration: "Bypass Moderation",
  moderateBulletinAdmittance: "Moderate Bulletin Admittance",
  manageMembers: "Manage Members",
  manageAdmins: "Manage Admins",
  flagBulletin: "Flag Bulletin",
  manageGroup: "Manage Group",
} as const;

export const USER_PERMISSION_TOOLTIPS = {
  bypassModeration: "User can bypass moderation requirements for bulletins",
  moderateBulletinAdmittance:
    "User can approve or reject bulletins submitted to the group",
  manageMembers: "User can add or remove regular members from the group",
  manageAdmins: "User can manage admins of the group",
  flagBulletin: "User can flag bulletins for review",
  manageGroup: "User can manage group settings",
} as const;

export interface BulletinTypeBypass {
  id: number;
  group_id: number;
  bulletin_type: string;
  created_by: string | null;
  time_created: string;
  time_updated: string;
}

export interface UserBypass {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
}

export interface GroupStats {
  totalMembers: number;
  activeMembers: number;
  pendingAlerts: number;
  bulletin_type_bypasses?: BulletinTypeBypass[];
  user_bypasses?: UserBypass[];
}

export const BYPASS_RULES_LABELS = {
  sectionTitle: "Bypass Rules",
  sectionDescription:
    "Configure which users and bulletin types can bypass moderation requirements",
  usersSubtitle: "Users with Bypass Permission",
  usersDescription:
    "These users can submit bulletins without requiring moderator approval",
  bulletinTypesSubtitle: "Bulletin Types that Bypass Moderation",
  bulletinTypesDescription:
    "Bulletins of these types are automatically approved without moderation",
  noUsers: "No users have bypass permission",
  noBulletinTypes: "No bulletin types bypass moderation",
} as const;
